<template>
  <div class="row gy-4">
    <div class="col-12">
      <stripe-element-payment
        class="c-stripe-checkout"
        :class="{'error': isError}"
        ref="stripePaymentRef"
        :pk="publishableKey"
        :elements-options="elementsOptions"
        :confirm-params="confirmParams"
        @error="markError()"
        @element-focus="disableError()"
      />
    </div>
    <div class="col-12">
      <button
        @click="pay()"
        :disabled="isCardLoading"
        class="c-button c-button--primary w-100"
        :class="{loading : isCardLoading}">
        {{
          (isCardLoading) ? 'Procesando pago...' : 'Pagar ahora'
        }}
        <img
          class="c-button__spinner"
          src="@/assets/images/animations/spinner-white.png"
          alt="loading"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { StripeElementPayment } from '@vue-stripe/vue-stripe';
import { mapState } from 'vuex';

export default {
  props: {
    userCheckout: Object,
    isCardLoading: Boolean,
    order: Number,
    cardError: Object,
    purchaseCode: String,
    clientSecret: String,

    buyEvent: Function,
  },
  components: {
    StripeElementPayment,
  },
  data() {
    return {
      isError: false,

      elementsOptions: {
        clientSecret: this.clientSecret,
        appearance: {
          variables: {
            colorPrimary: '#9bcf34',
            colorText: '#222',
            colorDanger: '#ff1d1d',
            fontFamily: 'Gilroy, Ideal Sans, system-ui, sans-serif',
            spacingUnit: '5px',
            borderRadius: '5px',
          },
          rules: {
            '.Input': {
              border: '2px solid #ebebeb',
            },
            '.Error': {
              fontSize: '14px',
            },
            '.Input:focus': {
              border: '2px solid #9bcf34',
              boxShadow: 'none',
            },
            '#stripe-payment-element-errors': {
              color: 'red',
            },
          },
        },
        locale: 'es-ES',
      },
      confirmParams: {
        return_url: (this.purchaseCode)
          ? `${process.env.VUE_APP_SITE}/panel/checkout/order-received/${this.order}?success=ok&pc=${this.purchaseCode}&vertion=v2`
          : `${process.env.VUE_APP_SITE}/panel/checkout/order-received/${this.order}?success=ok&vertion=v2`,
      },
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    publishableKey() {
      return process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
    },
  },
  methods: {
    pay() {
      this.$emit('update:userCheckout', {
        ...this.userCheckout,
        try: true,
      });

      this.isError = false;

      if (
        this.userCheckout.fullName.isValid
        && this.userCheckout.email.isValid
        && this.userCheckout.terms
      ) {
        this.$emit('update:isCardLoading', true);

        this.buyEvent();

        this.$refs.stripePaymentRef.submit();
      }
    },
    markError() {
      this.isError = true;

      this.$emit('update:isCardLoading', false);
    },
    disableError() {
      this.isError = false;
    },
  },
};
</script>
